import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export interface Bar {
  id: string;
  name: string;
  address: string;
  is_online: boolean;
  latitude: number | null;
  longitude: number | null;
  phone: string | null;
  instagram: string | null;
  description: string | null;
  created_at: string;
}

export function useBars() {
  const [bars, setBars] = useState<Bar[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchBars = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('bars')
        .select('*')
        .order('name');
      if (error) throw error;
      setBars(data || []);
    } catch (err) {
      console.error('Fetch bars error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBars();
  }, [fetchBars]);

  const updateBar = async (id: string, updates: Partial<Bar>) => {
    const { error } = await supabase.from('bars').update(updates).eq('id', id);
    if (error) throw error;
    await fetchBars();
  };

  return { bars, loading, refetch: fetchBars, updateBar };
}
